import React, { useMemo } from 'react';

import { format } from 'date-fns';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import CustomHeader from 'CommonComponents/DatePickerCustomHeader';

const DateRangePickerField = (props) => {
    const minMaxDatesConditionalPops = useMemo(() => {
        if (!props.min || !props.max) {
            return {};
        }

        return { minDate: new Date(props.min), maxDate: new Date(props.max) };
    }, [props.min, props.max]);

    const startDate = useMemo(() => (props.startDate ? new Date(props.startDate) : null), [props.startDate]);
    const endDate = useMemo(() => (props.endDate ? new Date(props.endDate) : null), [props.endDate]);

    return (
        <DatePicker
            selectsRange
            // Forwarded onto the underlying input so callers can give it an accessible name with a
            // <label htmlFor>. react-datepicker exposes no `aria-label` prop of its own.
            id={props.id}
            selected={startDate}
            startDate={startDate}
            endDate={endDate}
            renderCustomHeader={(headerProps) => CustomHeader({ ...headerProps, min: props.min, max: props.max })}
            className={props.className}
            wrapperClassName={props.wrapperClassName}
            placeholderText={props.placeholderText}
            onChange={([start, end]) => {
                start = start && props.valueFormat && typeof props.valueFormat === 'string' ? format(new Date(start), props.valueFormat) : start;
                end = end && props.valueFormat && typeof props.valueFormat === 'string' ? format(new Date(end), props.valueFormat) : end;
                props.onChange([start, end]);
            }}
            onCalendarClose={() => {
                if (typeof props.onCalendarClose === 'function') {
                    props.onCalendarClose();
                }
            }}
            dateFormat={props.dateFormat || 'd-M-yyyy'}
            autoComplete="off"
            autoFocus={props.autoFocus}
            disabled={props.disabled}
            showMonthYearPicker={props.showMonthYearPicker}
            customInput={props.customInput}
            {...minMaxDatesConditionalPops}
        />
    );
};

export default DateRangePickerField;
